<template>
  <div>
    <v-toolbar
      flat
      color="transparent"
    >
      <v-toolbar-title>קבצים משודכים</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="חיפוש"
        class="mr-3 ml-3"
      ></v-text-field>
    </v-toolbar>
    <v-data-table
      :loading="fetching"
      :search="search"
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      must-sort
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td
          v-for="(header, index) in headers"
          v-if="index < headers.length - 2"
        >
          <div v-if="header.linkTo">
            <router-link :to="header.linkTo(props.item)">
              {{ header.displayFunc(props.item) }}
            </router-link>
          </div>
          <div
            v-else
            v-html="header.displayFunc(props.item)"
          ></div>
        </td>
        <td>
          <div>
            <v-btn
              small
              icon
              flat
              class="mt-2 ml-0 mr-0"
              :loading="removing[props.item._id]"
              @click="edit({ entityId: props.item._id })"
            >
              <v-icon small>
                edit
              </v-icon>
            </v-btn>
          </div>
        </td>
        <td class="">
          <div>
            <v-btn
              small
              icon
              flat
              class="mt-2 ml-0 mr-0"
              :loading="removing[props.item._id]"
              @click="remove(props.item._id)"
            >
              <v-icon small>
                delete
              </v-icon>
            </v-btn>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  data() {
    return {
      fetching: false,
      removing: {},
      search: "",
      pagination: {},
      headers: [
        {
          text: "קובץ",
          value: "filename",
          align: "right",
          displayFunc: item => {
            return `<a href="${item.url}" target="_blank">${item.filename}</a>`;
          }
        },
        {
          text: "תיאור",
          value: "description",
          align: "right",
          displayFunc: item => {
            return item.description;
          }
        },
        {
          text: "אירוע",
          value: "eventTitle",
          align: "right",
          displayFunc: item => {
            return item.eventTitle;
          },
          linkTo: item => {
            return `/events/${item.eventId}`;
          }
        },
        {
          text: "תאריך אירוע",
          value: "eventStartDate",
          align: "right",
          displayFunc: item => {
            return format(item.eventStartDate, "DD/MM/YYYY");
          }
        },
        {
          text: "עריכה",
          value: "edit",
          sortable: false,
          width: "100px"
        },
        {
          text: "מחיקה",
          value: "delete",
          sortable: false,
          width: "100px"
        }
      ]
    };
  },
  computed: {
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    partnerId() {
      return this.$route.params.id;
    },
    resource() {
      return this.$store.state.resources.partnerEventFile;
    },
    files() {
      return Object.values(this.$store.state.entities.partnerEventFiles).filter(
        item => {
          return item.partner === this.partnerId;
        }
      );
    },
    items() {
      return this.files.map(item => {
        return {
          _id: item._id,
          eventId: item.event ? item.event._id || item.event : null,
          eventTitle: item.event
            ? item.event.title || "אירוע ללא שם"
            : "ללא אירוע",
          eventStartDate: item.event
            ? item.event.startDate || "תאריך לא ידוע"
            : "ללא אירוע",
          filename: item.originalFilename || "ללא שם",
          url: item.url,
          description: item.description
        };
      });
    }
  },
  methods: {
    fetch() {
      this.fetching = true;
      this.removing = [];
      this.$store
        .dispatch("API_GET", {
          url: this.resource.endpoint,
          entityType: this.resource.entityType,
          schema: this.resource.listSchema,
          params: {
            partners: this.partnerId,
            limit: 0
          },
          replace: true
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    edit({ entity, entityId, isNew = false }) {
      if (!entity) {
        entity = this.$store.state.entities[this.resource.entityType][entityId];
      }
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: this.resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    remove(id) {
      this.$confirm("האם למחוק קישור לקובץ? הקובץ עצמו לא ימחק").then(res => {
        if (!res) {
          return;
        }
        this.removeConfirmed(id);
      });
    },
    removeConfirmed(id) {
      this.removing[id] = true;
      this.$store
        .dispatch("REMOVE_ENTITY", {
          url: this.resource.endpoint,
          entityType: this.resource.entityType,
          id
        })
        .then(() => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "הקישור לקובץ נמחק",
            color: "success"
          });
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.removing[id] = false;
        });
    }
  },

  components: {},

  watch: {},
  mounted() {
    this.fetch();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partners/partner/Files.vue